import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import classes from './Sidebar.module.css'
import { menuItems, socialMediaData } from './SidebarData'
import { betkoPopupWithAction } from '../../../utils/BetkoPopupModal'
import { useAuthContext } from '../../../context/AuthProvider'
import axios from '../../../config/axios'
import { SERVER_URL } from '../../../helpers/urls'

const Sidebar = ({ onClose }) => {
  const [filledMenuItems, setFilledMenuItems] = useState(menuItems)
  const [activeMenuItem, setActiveMenuItem] = useState(null)
  const [activeSubmenu, setActiveSubmenu] = useState(null)
  const navigate = useNavigate()
  const { auth } = useAuthContext()

  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [])

  const toggleMenu = (menuItem) => {
    setActiveMenuItem((prev) => (prev === menuItem ? null : menuItem))
    setActiveSubmenu(null)
  }

  const toggleSubmenu = (name) => {
    setActiveSubmenu((prev) => (prev === name ? null : name))
  }

  const handleNavigation = (url, external = false) => {
    if (external) {
      window.open(url, '_blank', 'noopener,noreferrer')
    } else if (/^https?:\/\//.test(url)) {
      window.location.href = url
    } else {
      navigate(url)
    }

    onClose()
  }

  useEffect(() => {
    const fetchHelpMenu = async () => {
      try {
        const response = await axios.get(`${SERVER_URL}/help-menu?type=help`)
        const helpMenu = response.data

        const dynamicHelpChildren = helpMenu.map((section) => ({
          name: section.title,
          children: section.items.map((item) => ({
            name: item.title,
            url: item.url,
          })),
        }))

        console.log(dynamicHelpChildren)

        const updatedItems = menuItems.map((item) =>
          item.name === 'Pomoć'
            ? { ...item, children: dynamicHelpChildren }
            : item
        )

        setFilledMenuItems(updatedItems)
      } catch (error) {
        console.error('Failed to load help sections:', error)
      }
    }

    fetchHelpMenu()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className={classes.sidebar}>
      <div className={classes.authBtnWrapper}>
        {auth && Object.keys(auth).length < 1 ? (
          <button
            onClick={() => {
              navigate('/registracija_i_logovanje')
              onClose()
            }}
            className={classes.authBtn}
          >
            Prijavi se
          </button>
        ) : (
          <button
            onClick={() => {
              navigate('/moj_nalog')
              onClose()
            }}
            className={classes.authBtn}
          >
            Moj nalog
          </button>
        )}

        <button
          className={classes.addShortcut}
          onClick={(e) =>
            betkoPopupWithAction(
              'Instaliraj Betko prečicu na svoj telefon',
              '',
              () => (
                <div>
                  <p
                    style={{
                      color: '#d6ff00',
                      fontWeight: 'bold',
                      marginTop: '-10px',
                    }}
                  >
                    ANDROID
                  </p>
                  <p>
                    - Uđi na <a href='betkotip.com'>betkotip.com</a> u
                    pretraživaču na svom mobilnom telefonu.
                    <br />
                    - Klikni na tri tačkice u gornjem desnom uglu.
                    <br />
                    - Pronađi opciju "Dodaj na početni ekran".
                    <br />- Postavi Betko ikonicu na svoj mobilni telefon.
                  </p>

                  <p
                    style={{
                      color: '#d6ff00',
                      fontWeight: 'bold',
                      marginTop: '10px',
                    }}
                  >
                    IPHONE
                  </p>
                  <p>
                    Ukoliko koristiš iPhone, da bi postavio Betko ikonicu na
                    svoj početni ekran, potreban ti je “Safari” pretraživač.
                    <br />- Uđi na <a href='betkotip.com'>betkotip.com</a> u
                    pretraživaču na svom mobilnom telefonu.
                    <br />
                    - Klikni na dnu ekrana na navigacioni meni sa strelicom na
                    gore.
                    <br />
                    - Pronađi meni "Add to Home screen".
                    <br />- Postavi Betko ikonicu na svoj mobilni telefon.
                  </p>

                  <p
                    style={{
                      color: '#d6ff00',
                      fontWeight: 'bold',
                      marginTop: '10px',
                    }}
                  >
                    Napomena:
                  </p>
                  <p>
                    Podešavanja zavise od pretraživača, i mogu se od
                    pretraživača do pretraživača razlikovati, ali je proces
                    postavke Betko ikonica na tvoj telefon, veoma lak, brz i
                    jednostavan.
                  </p>
                </div>
              )
            )
          }
        >
          Instaliraj Betko ikonicu na svoj mobilni telefon
        </button>
        <button
          className={classes.askBetko}
          onClick={() => window.open('http://m.me/betkobet1x2', '_blank')}
        >
          Pitaj Betka
        </button>
      </div>

      <div className={classes.linksContainer}>
        {filledMenuItems &&
          filledMenuItems.map((menuItem, index) => (
            <div key={index} className={classes.menuItem}>
              <button
                onClick={() =>
                  menuItem.children
                    ? toggleMenu(menuItem.name)
                    : handleNavigation(menuItem.url, menuItem.external)
                }
                className={`${classes.menuButton} ${
                  activeMenuItem === menuItem.name ? classes.activeMenuItem : ''
                } ${menuItem.external ? classes.externalMenuItem : ''}`}
              >
                <div className={`imageWrapper ${classes.itemIconWrapper}`}>
                  <img
                    src={`/icons/sidebar/${menuItem.icon}.svg`}
                    alt={menuItem.name}
                  />
                </div>
                {menuItem.name}
                {menuItem.children && (
                  <div className={`imageWrapper ${classes.submenuIconWrapper}`}>
                    <img src='/icons/submenu-active.svg' alt='submenu icon' />
                  </div>
                )}
                {menuItem.external && (
                  <div className={`imageWrapper ${classes.submenuIconWrapper}`}>
                    <img src='/icons/arrow-right-.svg' alt='external link' />
                  </div>
                )}
              </button>

              {activeMenuItem === menuItem.name && menuItem.children && (
                <div className={classes.submenu}>
                  {menuItem.children.map((section, sIndex) => {
                    const isSubsection = Array.isArray(section.children)
                      ? section.children.length >= 0
                      : false
                    return (
                      <div key={sIndex} className={classes.menuItem}>
                        {isSubsection ? (
                          <div className={classes.innerMenu}>
                            <button
                              onClick={() => toggleSubmenu(section.name)}
                              className={`${classes.menuButton} ${
                                activeSubmenu === section.name
                                  ? classes.activeMenuItem
                                  : ''
                              }`}
                            >
                              {section.name}
                              <div
                                className={`imageWrapper ${classes.submenuIconWrapper}`}
                              >
                                <img
                                  src='/icons/submenu-active.svg'
                                  alt='submenu icon'
                                />
                              </div>
                            </button>
                            {activeSubmenu === section.name && (
                              <div className={classes.submenu}>
                                {section.children.map((item, itemIdx) => (
                                  <button
                                    key={itemIdx}
                                    onClick={() => handleNavigation(item.url)}
                                    className={classes.submenuButton}
                                  >
                                    {item.name}
                                  </button>
                                ))}
                              </div>
                            )}
                          </div>
                        ) : (
                          <button
                            onClick={() => handleNavigation(section.url)}
                            className={classes.submenuButton}
                          >
                            {section.name}
                          </button>
                        )}
                      </div>
                    )
                  })}
                </div>
              )}
            </div>
          ))}
      </div>

      <div className={classes.sidebarFooter}>
        <div className={classes.sidebarSocialMediaBtns}>
          {socialMediaData.map((item, index) => (
            <a target='_blank' key={index} href={item.url}>
              <img
                src={`/icons/social-media/${item.name}.svg`}
                alt={item.name}
              />
            </a>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Sidebar
